import _map from "lodash/map";
import _includes from "lodash/includes";
import { StepSlugs, YodleeStepSlugs } from "../../constants";
import { getTopProviderType, getSelectedProviderId } from "../../selectors";
export var isAuthStep = function isAuthStep(step) {
  return _includes([StepSlugs.SIGN_IN, StepSlugs.REGISTER], step.slug);
};
export var isRegisterStep = function isRegisterStep(step) {
  return step.slug === StepSlugs.REGISTER;
};
export var isTUVerificationSlug = function isTUVerificationSlug(step) {
  return _includes([StepSlugs.SHORT_SSN, StepSlugs.FULL_INFO], step.slug);
};
export var isYodleeStep = function isYodleeStep(step) {
  return _includes(_map(YodleeStepSlugs, function (val) {
    return val;
  }), step.slug);
};
export var getStandardYodleeParams = function getStandardYodleeParams(identity) {
  return {
    provider_type: getTopProviderType(identity),
    provider_id: getSelectedProviderId(identity)
  };
};